import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { ChevronDown, HelpCircle } from 'lucide-react';
const faqs = [{
  q: '¿Tengo que dejar de comer tortillas y arroz?',
  a: 'No. Te enseñamos a comerlos en el orden correcto y con los "hacks" de fibra para que tu glucosa no suba.'
}, {
  q: '¿Es difícil de seguir si trabajo mucho?',
  a: 'Al contrario. Está diseñado para el trabajador en USA. Incluye guías rápidas de supermercado y trucos que toman 10 segundos.'
}, {
  q: 'Mi doctor ya me dio medicina, ¿esto me sirve?',
  a: '¡Absolutamente! Este plan apoya cualquier tratamiento médico optimizando lo más importante: tu alimentación básica.'
}];
export function FAQ() {
  const [openIndex, setOpenIndex] = useState<number | null>(0);
  return <section className="py-20 bg-cream-light" data-id="element-27">
      <div className="max-w-3xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-28">
        <div className="text-center mb-12" data-id="element-29">
          <HelpCircle className="w-12 h-12 text-gold mx-auto mb-4" data-id="element-30" />
          <h2 className="text-3xl md:text-4xl font-bold text-forest-dark" data-id="element-31">
            Preguntas Frecuentes
          </h2>
        </div>

        <div className="space-y-4" data-id="element-32">
          {faqs.map((faq, index) => <div key={index} className="bg-white border border-gray-200 rounded-2xl overflow-hidden shadow-sm" data-id="element-33">
              <button onClick={() => setOpenIndex(openIndex === index ? null : index)} className="w-full px-6 py-5 text-left flex justify-between items-center focus:outline-none" data-id="element-34">
                <span className="font-bold text-lg text-forest-dark pr-4" data-id="element-35">
                  ❓ {faq.q}
                </span>
                <ChevronDown className={`w-5 h-5 text-gold transition-transform duration-300 ${openIndex === index ? 'rotate-180' : ''}`} data-id="element-36" />
              </button>

              <AnimatePresence data-id="element-37">
                {openIndex === index && <motion.div initial={{
              height: 0,
              opacity: 0
            }} animate={{
              height: 'auto',
              opacity: 1
            }} exit={{
              height: 0,
              opacity: 0
            }} transition={{
              duration: 0.3
            }} data-id="element-38">
                    <div className="px-6 pb-5 text-gray-600 border-t border-gray-50 pt-4" data-id="element-39">
                      <span className="font-medium text-forest" data-id="element-40">✅</span>{' '}
                      {faq.a}
                    </div>
                  </motion.div>}
              </AnimatePresence>
            </div>)}
        </div>
      </div>
    </section>;
}